module.exports = new __parcel__URL__("temperature-monitoring.c38f4129.svg").toString();